import React from "react"
import Icon from "@ant-design/icons"
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon"

const UsersSvg = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24.64 22.73"
        xmlSpace="preserve"
        width="1em"
        height="1em"
    >
        <g fill="#787698">
            <path d="M4.2 16.63c.14-.59.38-1.14.71-1.64.67-1.03 1.58-1.76 2.71-2.23.05-.02.1-.04.16-.07-.77-.77-1.11-1.67-.94-2.74.13-.87.58-1.56 1.31-2.06 1.53-1.06 3.8-.5 4.57 1.36.42-.23.85-.46 1.28-.7-.78-.78-1.11-1.73-.91-2.85.13-.72.5-1.32 1.07-1.78 1.22-.98 2.9-.92 4.06.18.64.61.95 1.37.94 2.25-.01.87-.36 1.61-.97 2.2.38.22.76.42 1.13.64.38.24.41.72.08.98a.57.57 0 0 1-.7.04c-.37-.23-.74-.45-1.15-.58-1.7-.52-3.22-.2-4.56.98-.04.03-.07.09-.07.14-.09.74-.4 1.37-.94 1.89-.01.01-.02.02-.03.05.16.08.33.14.48.23.23.13.46.25.67.4.3.2.37.55.19.83-.18.29-.54.37-.84.17-.56-.36-1.15-.63-1.81-.74-1.17-.19-2.26.02-3.26.64-.9.55-1.54 1.33-1.9 2.33-.18.5.09.89.62.89h5.09c.35 0 .6.19.66.49.05.27-.07.49-.38.68H5.63c-.04-.02-.08-.04-.12-.05-.39-.11-.7-.34-.94-.66-.19-.25-.28-.55-.35-.85-.02-.13-.02-.28-.02-.42zm5.66-8.07C8.83 8.56 8 9.4 8 10.43c0 1.02.85 1.87 1.87 1.86 1.03-.01 1.86-.85 1.86-1.87a1.878 1.878 0 0 0-1.87-1.86zm8.1-2.25a1.865 1.865 0 1 0-3.73-.01 1.865 1.865 0 0 0 3.73.01z" />
            <path d="M16.54 18.62c-.29-.15-.4-.39-.39-.71.01-.45 0-.9 0-1.35v-.16h-1.62c-.37 0-.64-.26-.64-.6 0-.34.27-.6.64-.6h1.62v-1.66c0-.29.21-.53.5-.58.27-.05.55.1.65.35.04.09.05.2.05.31.01.52 0 1.04 0 1.59h1.66c.29 0 .53.21.58.5.05.27-.1.56-.37.65a.84.84 0 0 1-.31.05h-1.57v.16c0 .45-.01.9 0 1.35.01.32-.1.57-.39.71-.12-.01-.27-.01-.41-.01z" />
        </g>
    </svg>
)

export const UsersIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={UsersSvg} {...props}/>
)
